var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.83817 8.83636H3.9017C3.39282 8.83636 2.98301 8.66753 2.70089 8.38541C2.41876 8.10328 2.24994 7.69347 2.24994 7.18459V3.514C2.24994 3.00512 2.41876 2.59532 2.70089 2.31319C2.98301 2.03107 3.39282 1.86224 3.9017 1.86224H6.83817C7.34705 1.86224 7.75686 2.03107 8.03898 2.31319C8.32111 2.59532 8.48994 3.00512 8.48994 3.514V7.18459C8.48994 7.69347 8.32111 8.10328 8.03898 8.38541C7.75686 8.66753 7.34705 8.83636 6.83817 8.83636Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.367059
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50257 3.99243C4.57452 3.06488 6.16469 3.06379 7.23433 3.98824L6.48157 5.1968C5.83592 4.65898 4.89838 4.65898 4.25273 5.1968L3.50257 3.99243Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.367059
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipient);
export default __webpack_public_path__ + "static/media/Recipient.9203421acd098d905296078a829ff5c4.svg";
export { ForwardRef as ReactComponent };